import { SyncOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const RefreshButton = (args) => {
  return (
    <Button size="small" {...args} icon={<SyncOutlined />}>
      {args.title || $t("Sync")}
    </Button>
  );
};
